import { render, staticRenderFns } from "./ReminderProductAvailability.vue?vue&type=template&id=398fc878&scoped=true"
import script from "./ReminderProductAvailability.vue?vue&type=script&lang=js"
export * from "./ReminderProductAvailability.vue?vue&type=script&lang=js"
import style0 from "./ReminderProductAvailability.vue?vue&type=style&index=0&id=398fc878&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398fc878",
  null
  
)

export default component.exports